import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "./Header";
import Footer from './Footer';
import HomepagePricingSection from './HomepagePricingSection';
import { Bot, Users, UserCheck, Mic, Target, Workflow, Zap, ArrowRight, Sparkles, BarChart3, MessageSquare, Phone, ChevronRight, Shield, FileText } from 'lucide-react';

import { motion, AnimatePresence } from "framer-motion";

//images
import HomeAIEmailCrafting from "../../assets/img/home_img/home_AIEmailCrafting.jpg";
import HomeAutomateFollowups from "../../assets/img/home_img/home_AutomateFollowups.jpg"
import HomeLeadEnrichment from "../../assets/img/home_img/home_LeadEnrichment.jpg"
import HomeAutopilot from "../../assets/img/home_img/home_Autopilot.png"
import HomeMutiVoiceCloning from "../../assets/img/home_img/home_voiceCloning.jpg"
import HomeAIProposalGeneration from "../../assets/img/home_img/home_AIProposalGeneration.jpg"
import HomeBuyingIntentScore  from "../../assets/img/home_img/home_buyingIntentScore.jpg"
import HomeLinkedInGhostwriter  from "../../assets/img/home_img/home_LinkedInGhostwriter.png"





import HomeDashboard from "../../assets/img/home_img/home_dashboard_gif.gif"
import HomeManuallFill from "../../assets/img/home_img/home_manualfill.jpeg"
import HomecampaignAssistent from "../../assets/img/home_img/home_campaignAssistant.jpeg"
import AnnaImage from "../../assets/female_avatar.png"
import HomeSequence from "../../assets/img/home_img/home_sequences.png"



// ==== ICONS (unchanged APIs so your code elsewhere still works) ====
const CheckCircle = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);
const Star = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);
const Rocket = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.3.05-3.12-.65-.82-2.17-1.43-3.12-1.88z" /><path d="M12 15.5V13a2 2 0 0 0-2-2H8.5" /><path d="M16 10.5a5.5 5.5 0 0 0-5.5-5.5" /><path d="M12 2.5a2.5 2.5 0 0 1 2.5 2.5" /><path d="M19 13a2.5 2.5 0 0 1 2.5 2.5" /><path d="M19 19.5a5.5 5.5 0 0 0-5.5-5.5" /><path d="M21.5 4.5c-1.26 1.5-5 2-5 2s.5 3.74 2 5c.84.71 2.3.7 3.12.05.82-.65 1.43-2.17 1.88-3.12z" />
  </svg>
);
// const UserCheck = ({ className }) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
//     <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><polyline points="16 11 18 13 22 9" />
//   </svg>
// );
const TrendingUp = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" /><polyline points="16 7 22 7 22 13" />
  </svg>
);
const Mail = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);
// const Bot = ({ className }) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
//     <path d="M12 8V4H8" /><rect width="16" height="12" x="4" y="8" rx="2" /><path d="M2 14h2" /><path d="M20 14h2" /><path d="M15 13v2" /><path d="M9 13v2" />
//   </svg>
// );
// const Mic = ({ className }) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
//     <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" /><path d="M19 10v2a7 7 0 0 1-14 0v-2" /><line x1="12" x2="12" y1="19" y2="22" />
//   </svg>
// );
// const FileText = ({ className }) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
//     <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" /><polyline points="14 2 14 8 20 8" /><line x1="16" x2="8" y1="13" y2="13" /><line x1="16" x2="8" y1="17" y2="17" /><line x1="10" x2="8" y1="9" y2="9" />
//   </svg>
// );
// const Target = ({ className }) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
//     <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" />
//   </svg>
// );
// const Workflow = ({ className }) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
//     <rect width="8" height="8" x="3" y="3" rx="2" /><path d="M7 11v4a2 2 0 0 0 2 2h4" /><rect width="8" height="8" x="13" y="13" rx="2" />
//   </svg>
// );
// const ArrowRight = ({ className }) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
//     <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
//   </svg>
// );
// const Twitter = ({ className }) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M22 4s-.7 2.1-2 3.4c1.6 1.4 2.8 3.2 3 5.2-1.4 1-3.2 1.9-5 2.4-2.2 2.8-5.3 3.9-9 3.4-3.4-.5-6-2.4-7.4-5.2-3-7.9 1.5-13.4 8.5-13.2 3.8.1 6.8 1.4 9 3.2z" /></svg>
// );
const Linkedin = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></svg>
);

// ======== UTIL: in-view animation ========
const useOnScreen = (options) => {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setIsVisible(true); obs.unobserve(ref.current); }
    }, options);
    if (ref.current) obs.observe(ref.current);
    return () => { if (ref.current) obs.unobserve(ref.current); };
  }, [ref, options]);
  return [ref, isVisible];
};
const AnimatedSection = ({ children, className, id }) => {
  const [ref, isVisible] = useOnScreen({ threshold: 0.1 });
  return (
    <section ref={ref} id={id} className={`${className} transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>{children}</section>
  );
};

// ======== CONTENT (same objects so no logic breaks) ========
const hero = {
  tagline: "Transform Your Business’s Outreach Strategy with AI",
  subheading: "Connect with leads, build relationships, and drive growth like never before. Roboman is your intelligent partner for personalized, effective outreach campaigns.",
  ctaPrimary: "Starts with 100 Free Credits",
  ctaSecondary: "See a Demo",
  ctaNote: "Explore all features with 100 free credits. No payment required.",
};

// const hero = {
//   tagline: "Deliver More Client Meetings—Without More Headcount",
//   subheading:
//     "Roboman helps agencies run personalized outreach across email, LinkedIn, voice notes, and proposals. Intent scoring prioritizes hot leads so your team focuses where it converts.",
//   ctaPrimary: "Start Free — 100 Credits",
//   ctaSecondary: "Book a Demo",
//   ctaNote: "Perfect for client campaigns, reporting, and repeatable playbooks.",
// };

const benefits = {
  items: [
    { id: 1, icon: TrendingUp, title: "Boost Reply Rates", text: "Leverage AI to craft hyper-personalized messages that resonate and get responses." },
    { id: 2, icon: UserCheck, title: "Qualify Leads Faster", text: "Our system analyzes lead profiles to identify your most promising prospects automatically." },
    { id: 3, icon: Rocket, title: "Scale Your Outreach", text: "Reach thousands of potential customers without sacrificing the personal touch." }
  ]
};
const featuresContent = [
  {
    id: 1,
    Icon: Mail,
    title: "AI Email Crafting",
    description: "Generate compelling, personalized email sequences in seconds. Overcome writer's block forever.",

    outcome: "3× higher reply rates",
    aiDecision: "Chooses subject lines, tone, and CTA based on lead profile",
    channels: ["Email"],
    trigger: "When a new lead is added",
    automationLevel: "Full Autopilot",
    personalizationSource: ["LinkedIn Profile", "Company Website", "CRM Data"],
    intentStage: "Cold → Warm",


    bgColor: "bg-blue-100",
    iconColor: "text-blue-600",
    image: HomeAIEmailCrafting,
    previewType: "image",

    status: "Most Used",
    cta: { label: "Try AI Email", link: "/features/ai-email" },
  },

  {
    id: 2,
    Icon: Bot,
    title: "Automated Follow-ups",
    description: "Never let a lead slip through the cracks. Roboman intelligently follows up based on engagement.",

    outcome: "No missed replies, ever",
    aiDecision: "Decides whether to wait, follow up, or switch channel",
    channels: ["Email", "LinkedIn"],
    trigger: "If no response within 24–72 hours",
    automationLevel: "Full Autopilot",
    personalizationSource: ["Open Rate", "Click Activity", "Reply History"],
    intentStage: "Warm → Hot",

    bgColor: "bg-green-100",
    iconColor: "text-green-600",
    image: HomeAutomateFollowups,
    previewType: "image",

    status: "Core Feature",
    cta: { label: "Automate Follow-ups", link: "/features/follow-ups" },
  },

  {
    id: 3,
    Icon: UserCheck,
    title: "Lead Enrichment",
    description: "Automatically find and verify contact information, adding valuable context to your outreach.",

    outcome: "Richer profiles, better personalization",
    aiDecision: "Selects best data points to personalize outreach",
    channels: ["Email", "LinkedIn"],
    trigger: "When lead is imported",
    automationLevel: "Background Automation",
    personalizationSource: ["Company Data", "Role", "Industry", "Location"],
    intentStage: "Cold",

    bgColor: "bg-purple-100",
    iconColor: "text-purple-600",
    image: HomeLeadEnrichment,
    previewType: "illustration",

    status: "Always On",
    cta: { label: "Enrich Leads", link: "/features/lead-enrichment" },
  },

  {
    id: 4,
    Icon: Mic,
    title: "Multilingual Voice Cloning",
    description: "Clone your voice once. Deliver personalized voice notes in any language across the globe.",

    outcome: "Build trust at scale",
    aiDecision: "Chooses language and timing for voice outreach",
    channels: ["Voice", "LinkedIn"],
    trigger: "When lead shows high intent",
    automationLevel: "Human-like Autopilot",
    personalizationSource: ["User Voice", "Lead Language", "Region"],
    intentStage: "Warm → Hot",

    bgColor: "bg-red-100",
    iconColor: "text-red-600",
    image:HomeMutiVoiceCloning,
    previewType: "video",

    status: "Unique",
    cta: { label: "Try Voice Outreach", link: "/features/voice" },
  },

  {
    id: 5,
    Icon: FileText,
    title: "AI Proposal Generation",
    description: "Our AI crafts tailored proposals and presentations that pinpoint gaps and highlight ROI.",

    outcome: "Close deals faster",
    aiDecision: "Decides proposal timing based on buying signals",
    channels: ["Proposal"],
    trigger: "When intent score crosses threshold",
    automationLevel: "AI Assisted",
    personalizationSource: ["Lead Pain Points", "Conversation History"],
    intentStage: "Hot",

    bgColor: "bg-yellow-100",
    iconColor: "text-yellow-600",
    image: HomeAIProposalGeneration,
    previewType:"Proposal",

    status: "High Impact",
    cta: { label: "Generate Proposal", link: "/features/proposals" },
  },

  {
    id: 6,
    Icon: Target,
    title: "Buying Intent Scoring",
    description: "Our AI ranks every lead by their buying intent, so you focus where it matters.",

    outcome: "Focus only on ready-to-buy leads",
    aiDecision: "Scores leads based on behavior and engagement",
    channels: ["All"],
    trigger: "Real-time activity tracking",
    automationLevel: "Continuous AI",
    personalizationSource: ["Clicks", "Replies", "Site Visits"],
    intentStage: "Cold → Hot",

    bgColor: "bg-indigo-100",
    iconColor: "text-indigo-600",
    image: HomeBuyingIntentScore,
    previewType: "chart",

    status: "AI Core",
    cta: { label: "View Intent Scores", link: "/features/intent" },
  },

  {
    id: 7,
    Icon: Workflow,
    title: "Autopilot",
    description: "From voice notes to LinkedIn messages and proposals, Autopilot runs everything.",

    outcome: "Hands-free outreach",
    aiDecision: "Chooses next best action automatically",
    channels: ["Email", "LinkedIn", "Voice", "Proposal"],
    trigger: "Based on lead behavior",
    automationLevel: "End-to-End Autopilot",
    personalizationSource: ["Full Lead Timeline"],
    intentStage: "All Stages",

    bgColor: "bg-pink-100",
    iconColor: "text-pink-600",
    image:HomeAutopilot,
    previewType: "flow",

    status: "Flagship",
    cta: { label: "Enable Autopilot", link: "/features/autopilot" },
  },

  {
    id: 8,
    Icon: Linkedin,
    title: "AI LinkedIn Ghostwriter ",
    description: "Automate personalized connection requests and follow-ups that sound like you.",

    outcome: "Human conversations at scale",
    aiDecision: "Writes messages matching your tone and context",
    channels: ["LinkedIn"],
    trigger: "When connection is accepted",
    automationLevel: "Smart Automation",
    personalizationSource: ["Profile Data", "Mutual Context"],
    intentStage: "Cold → Warm",

    bgColor: "bg-blue-100",
    iconColor: "text-blue-600",
    image: HomeLinkedInGhostwriter ,
    previewType: "image",

    status: "Popular",
    cta: { label: "Try LinkedIn AI", link: "/features/linkedin" },
  },
];

const testimonials = {
  items: [
    { id: 1, name: "Sarah L.", role: "Marketing Director @ TechCorp", feedback: "Roboman has been a game-changer for our lead generation. We've seen a 3x increase in qualified meetings since we started.", avatarUrl: "https://placehold.co/100x100/f0abfc/4a044e?text=SL", rating: 5 },
    { id: 2, name: "David Chen", role: "Founder, StartupX", feedback: "As a small team, we need to be efficient. The automation and AI save us at least 10 hours a week. It's indispensable.", avatarUrl: "https://placehold.co/100x100/93c5fd/1e3a8a?text=DC", rating: 5 },
    { id: 3, name: "Maria Garcia", role: "Sales Manager", feedback: "The personalization is what sets Roboman apart. It doesn't feel like an automated email, and our prospects notice that.", avatarUrl: "https://placehold.co/100x100/a7f3d0/052e16?text=MG", rating: 5 }
  ]
};
const pricingData = {
  currencies: [
    { id: 'USD', symbol: '$', name: 'USA (USD)' },
    { id: 'GBP', symbol: '£', name: 'UK (GBP)' },
    { id: 'CAD', symbol: 'C$', name: 'Canada (CAD)' },
    { id: 'AUD', symbol: 'A$', name: 'Australia (AUD)' },
    { id: 'INR', symbol: '₹', name: 'India (INR)' },
  ],
  plans: [
    { id: 1, title: "Starter", credits: "500", prices: { INR: "3,499", USD: "49", GBP: "39.99", CAD: "69.99", AUD: "79.99" }, vat: { GBP: true }, features: ["50 Companies OR", "20 Business Proposals", "100 Voice Notes", "250 Emails/Messages"], mixExample: { title: "Mix Example:", items: ["20 intent signals", "50 emails", "30 voice notes", "2 proposals"] }, recommended: false },
    { id: 2, title: "Growth", credits: "1,000", prices: { INR: "6,999", USD: "99", GBP: "79.99", CAD: "139.99", AUD: "159.99" }, vat: { GBP: true }, features: ["100 Companies OR", "40 Business Proposals", "200 Voice Notes", "500 Emails/Messages"], mixExample: { title: "Mix Example:", items: ["40 intent signals", "100 emails", "60 voice notes", "4 proposals"] }, recommended: true },
    { id: 3, title: "Pro", credits: "2,000", prices: { INR: "13,999", USD: "199", GBP: "159.99", CAD: "279.99", AUD: "319.99" }, vat: { GBP: true }, features: ["200 Companies OR", "80 Business Proposals", "400 Voice Notes", "1000 Emails/Messages"], mixExample: { title: "Mix Example:", items: ["80 intent signals", "200 emails", "120 voice notes", "8 proposals"] }, recommended: false },
    { id: 4, title: "Enterprise", credits: "Custom", prices: { INR: "Custom", USD: "Custom", GBP: "Custom", CAD: "Custom", AUD: "Custom" }, priceInfo: "Starts at $499+", features: ["Custom Credit Amount", "Dedicated Account Manager", "API Access & Support", "Custom Onboarding & Training"], recommended: false }
  ]
};
const finalCta = {
  prompt: "Ready to Revolutionize Your Outreach?",
  buttonText: "Claim Your 100 Free Credits Trial to Start Today",
  note: "No credit card required. Explore all features with 100 free credits."
};

const tabs = [
  { id: 'campaigns', label: 'Campaigns', icon: BarChart3 },
  { id: 'email', label: 'Email', icon: Mail },
  { id: 'linkedin', label: 'LinkedIn', icon: Linkedin },
];
const highlights = [
  {
    text: 'Live campaign tracking',
    icon: TrendingUp,
    stat: '94% accuracy',
    color: 'from-blue-300 to-cyan-300'
  },
  {
    text: 'Email & LinkedIn performance',
    icon: Users,
    stat: '2.4x engagement',
    color: 'from-purple-300 to-pink-300'
  },
  {
    text: 'AI-powered intent scoring',
    icon: Zap,
    stat: '87% conversion',
    color: 'from-orange-300 to-red-300'
  },
];
const channelIcons = {
  Email: Mail,
  LinkedIn: Linkedin,
  SMS: MessageSquare,
  Phone: Phone,
  Chat: MessageSquare
};


// ======== UNIQUE VISUALS ========
const NeonCard = ({ children, className = '' }) => (
  <div className={`relative rounded-2xl p-[1px] bg-gradient-to-b from-indigo-500/30 via-fuchsia-500/20 to-purple-500/30 shadow-[0_0_0_1px_rgba(99,102,241,0.08)] ${className}`}>
    <div className="rounded-2xl bg-white/80 backdrop-blur-xl p-6">
      {children}
    </div>
  </div>
);

const Ribbon = ({ text }) => (
  <div className="absolute -top-3 left-4 inline-flex items-center gap-2 rounded-full bg-slate-900 text-slate-100 px-3 py-1 text-[11px] font-semibold shadow-lg">
    <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" /> {text}
  </div>
);

const Marquee = ({ items }) => (
  <div className="relative overflow-hidden group bg-violet-100
    [mask-image:linear-gradient(to_right,black_30%,black_90%,transparent)]">

    <div className="
      flex gap-6
      animate-[scroll_28s_linear_infinite]
      group-hover:[animation-play-state:paused]
      will-change-transform
    ">
      {[...items, ...items].map((it, i) => (
        <span
          key={i}
          className="
            inline-flex items-center gap-2 px-4 py-2 rounded-xl
            bg-white/80 backdrop-blur-md
            ring-1 ring-slate-200
            text-slate-700 text-sm font-medium
            transition-all duration-300
            hover:-translate-y-1 hover:scale-105
            hover:shadow-lg hover:shadow-emerald-200/50
            hover:ring-emerald-300
            cursor-pointer
          "
        >
          <CheckCircle className="h-4 w-4 text-emerald-500 transition-transform duration-300 group-hover:rotate-12" />
          {it}
        </span>
      ))}
    </div>
  </div>
);



// ======== PAGE ========
const HomeNew = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  // const [selectedCurrency, setSelectedCurrency] = useState('USD');
  const [activeTab, setActiveTab] = useState('campaigns');
  const [hoveredCard, setHoveredCard] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [activeFeature, setActiveFeature] = useState(0);
  const [pointingTo, setPointingTo] = useState('left');
  const navigate = useNavigate();

  useEffect(() => {

    //create your campaign using anna or manual
    const interval = setInterval(() => {
      setPointingTo(prev => prev === 'left' ? 'right' : 'left');
    }, 3000);

    const onScroll = () => setIsScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
      clearInterval(interval);
    }
  }, []);

  const handleScheduleClick = () => {
    window.Calendly?.initPopupWidget({ url: 'https://calendly.com/priyeshsharad/roboman' });
  };

  return (
    <div className="bg-white text-slate-800 font-sans antialiased">
      {/* Page-only CSS (no deps) */}
      <style>{`
       body, html {
       overflow-x: hidden;
       max-width: 100vw;
      }

        .grid-bg { background-image: radial-gradient(circle at 1px 1px, rgba(15,23,42,.08) 1px, transparent 0); background-size: 24px 24px; }
        @keyframes floaty { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
        @keyframes blob { 0%{transform:translate(0,0) scale(1);} 33%{transform:translate(20px,-10px) scale(1.05);} 66%{transform:translate(-10px,14px) scale(.98);} 100%{transform:translate(0,0) scale(1);} }
        @keyframes scroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .tilt:hover { transform: perspective(800px) rotateX(3deg) rotateY(-6deg) translateY(-2px); }
      `}</style>

      <Header isScrolled={isScrolled} />

      <main className="overflow-hidden max-w-full" >

        {/* ===== HERO (split, with neon device stack) ===== */}
        <section className="relative isolate pt-24 pb-20 overflow-hidden ">
          <div className="absolute inset-0 -z-10 bg-gradient-to-b from-indigo-50 via-white to-white  " />
          <div className="absolute -top-40 -left-24 h-[32rem] w-[32rem] bg-fuchsia-300/3 blur-3xl rounded-full mix-blend-multiply animate-[blob_12s_ease-in-out_infinite]" />
          <div className="absolute -top-48 -right-24 h-[36rem] w-[36rem] bg-indigo-200/30 blur-3xl rounded-full mix-blend-multiply animate-[blob_16s_ease-in-out_infinite]" />
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid  grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center">

              {/* left column */}
              <div className="lg:col-span-6 ">
                <span className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1 text-xs font-semibold ring-1 ring-slate-200">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-600 animate-pulse" />
                  New: Voice Notes in Autopilot
                </span>

                <motion.h1
                  initial={{ opacity: 0, x: -100 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                  className="mt-4 text-2xl sm:text-3xl  md:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
                  {hero.tagline}
                </motion.h1>

                <p className="mt-6 text-base sm:text-lg text-slate-700 max-w-xl">
                  {hero.subheading}
                </p>

                <div className="mt-8 flex flex-col sm:flex-row   flex-wrap gap-4">
                  <button onClick={() => navigate('/signup')}
                    className="inline-flex items-center justify-center  gap-2 rounded-2xl bg-slate-800 text-white px-6 py-3 font-semibold shadow-lg hover:bg-slate-800 transition-all hover:scale-[1.02]"
                  >
                    {hero.ctaPrimary} <ArrowRight className="h-5 w-5" />
                  </button>

                  <button onClick={handleScheduleClick}
                    className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-6 py-3 font-semibold text-slate-900 ring-1 ring-slate-200 shadow-md hover:bg-slate-100">
                    {hero.ctaSecondary}
                  </button>
                </div>
                <p className="mt-4 text-xs text-slate-500">{hero.ctaNote}</p>

                {/* marquee */}
                <div className="mt-8">
                  <Marquee items={['AI Emails', 'LinkedIn steps', 'Voice notes', 'Proposals', 'Intent scoring', 'CRM sync']} />
                </div>
              </div>

              {/* Right column */}
              <div className="lg:col-span-6 w-full rounded-2xl"
                style={{
                  backgroundImage: "url(https://tse2.mm.bing.net/th/id/OIP.-WBFULdG5WMC7XHDvCOpogHaEJ?pid=Api&P=0&h=180)",
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'left center',
                  backgroundSize: 'cover',
                }}>
                <div className="relative mx-auto max-w-xl" >
                  <div className="absolute -inset-6 -z-10 rounded-[2rem] bg-gradient-to-br from-indigo-200/20 via-fuchsia-200/20 to-purple-200/20 blur-2xl" />
                  <div className="space-y-4 sm:space-y-6">

                    {/* Card 1 */}
                    <NeonCard className="tilt transition-transform">
                      <Ribbon text="Inbox-ready Emails" />
                      <motion.div
                        initial={{ opacity: 0, x: 100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        viewport={{ once: true }}
                        className="flex item-start sm:items-center gap-3 sm:gap-4 sm:flex-row">
                        <div className="h-10 w-10 flex-shrink-0 rounded-xl bg-blue-100 flex items-center justify-center ring-1 ring-black/5">
                          <Mail className="h-5 w-5 text-blue-600" />
                        </div>
                        <div className='flex-1'>
                          <p className="text-slate-900 font-semibold text-sm sm:text-base">
                            AI Email Crafting
                          </p>
                          <p className="text-slate-600 text-sm sm:text-sm">
                            Sequences that sound human—generated in seconds.
                          </p>
                        </div>
                      </motion.div>
                    </NeonCard>

                    {/* Card 2 */}
                    <NeonCard className="tilt transition-transform">
                      <Ribbon text="Multichannel Autopilot" />
                      <motion.div className="grid grid-cols-4 gap-2 sm:gap-2"
                        initial={{ opacity: 0, x: 100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        viewport={{ once: true }}>

                        {['Email', 'LinkedIn', 'Voice', 'Proposal'].map((t, i) => (
                          <div key={i} className="rounded-xl bg-white ring-1 ring-slate-200 sm:p-3 text-center animate-pulse">
                            <p className="text-[10px] sm:text-xs font-semibold text-slate-700">{t}</p>
                            <p className="mt-1 sm:mt-2 text-[9px] sm:text-[11px] text-emerald-600 font-bold">
                              Active
                            </p>
                          </div>
                        ))}
                      </motion.div>
                    </NeonCard>

                    {/* Card 3 */}
                    <NeonCard className="tilt transition-transform">
                      <Ribbon text="Buying Intent 9.4/10" />
                      <motion.div className="flex flex-start sm:items-center justify-between gap-3 flex-col sm:flex-row"
                        initial={{ opacity: 0, x: 100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        viewport={{ once: true }}>

                        <div className="flex items-center gap-3 flex-1">
                          <div className="h-10 w-10 flex-shrink-0 rounded-xl bg-indigo-100 flex items-center justify-center ring-1 ring-black/5">
                            <Target className="h-5 w-5 text-indigo-600" />
                          </div>
                          <div className='flex-1'>
                            <p className="text-slate-900 font-semibold text-sm sm:text-base">
                              Hot leads highlighted
                            </p>
                            <p className="text-slate-600 text-xs sm:text-sm">
                              Prioritize time where it converts.
                            </p>
                          </div>
                        </div>
                        <div className="h-10 w-20 sm:w-24  flex-shrink-0 rounded-full grid-bg flex items-center justify-center text-slate-900 text-sm font-bold">
                          +11%
                        </div>
                      </motion.div>
                    </NeonCard>

                  </div>
                </div>
              </div>

            </div>

            {/* trust chips */}
            <div className="mt-16 p-8">
              <p className="text-center text-[11px] font-semibold tracking-widest text-slate-500">
                TRUSTED BY MODERN GTM TEAMS
              </p>
              <div className="mt-4 mx-auto max-w-5xl grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
                {['TechCorp', 'StartupX', 'InnovateCo', 'Growth Inc.', 'ScaleUp', 'Nimbus'].map((n, i) => (
                  <div key={i} className="h-10 rounded-xl bg-white ring-1 ring-slate-200 flex items-center justify-center text-slate-600 font-semibold text-xs">
                    {n}
                  </div>
                ))}
              </div>
            </div>

          </div>
        </section>

        {/*===== dashboard  =====*/}
        <section className="relative py-14 sm:py-16 lg:py-20 xl:py-2 bg-gradient-to-r from-slate-50 via-slate-100 to-slate-100 overflow-hidden ">

          <div className="absolute inset-0 -z-10">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-56 h-56 sm:w-72 sm:h-72 lg:w-80 lg:h-80 bg-indigo-300/20 rounded-full blur-3xl" />
            <div className="absolute bottom-0 right-1/2 translate-x-1/2 w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 bg-purple-300/20 rounded-full blur-3xl" />
          </div>


          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

            <div className="max-w-2xl mx-auto text-center mb-16">

              <motion.h2
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true }}
                className="mt-4  sm:mt-6 text-xl sm:text-2xl  md:text-3xl lg:text-4xl font-bold  font-Inter opacity-1 bg-gradient-to-r from-gray-900 via-blue-800 to-fuchsia-800  bg-clip-text text-transparent ">
                One Dashboard. Every Outreach Signal.
              </motion.h2>

              <p className="mt-3 sm:mt-4 text-sm text-slate-500">
                Track campaigns, engagement, and buying intent across Email & LinkedIn.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 sm:gap-10 lg:gap-14 items-center">

              {/* LEFT Column*/}
              <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true }}
                className="lg:col-span-7 w-full relative min-h-[240px] sm:min-h-[320px] md:min-h-[420px] lg:min-h-[480px] xl:min-h-[520px] rounded-xl overflow-hidden "
                style={{
                  backgroundImage: `url(${HomeDashboard})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center top ',
                  backgroundSize: 'contain',
                }}>

                <div className="absolute -inset-4 bg-gradient-to-r from-indigo-200/20 via-purple-200/20 to-pink-200/20 blur-2xl rounded-lg z-0" />
              </motion.div>


              {/* RIGHT Column */}
              <div className="lg:col-span-5">

                {/* Tabs */}
                <div className="flex flex-wrap gap-2 mb-8">
                  {tabs.map((tab) => {
                    const Icon = tab.icon;
                    return (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition ${activeTab === tab.id
                          ? 'bg-gradient-to-r from-indigo-600 to-fuchsia-600  text-white shadow-sm'
                          : 'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50'
                          }`}
                      >
                        <Icon className="w-4 h-4" />
                        {tab.label}
                      </button>
                    );
                  })}
                </div>

                {/* Highlights */}
                <div className="space-y-5">
                  {highlights.map((item, i) => {
                    const Icon = item.icon;
                    return (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, x: 100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        viewport={{ once: true }}
                        className="flex gap-4 items-start rounded-2xl bg-white ring-1 ring-slate-200 p-5 shadow-sm hover:shadow-md transition bg-gradient-to-tr from-indigo-600/10 via-violet-600/10 to-fuchsia-600/10"
                      >
                        <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center`}>
                          <Icon className="w-5 h-5 text-white" />
                        </div>

                        <div>
                          <p className="font-semibold text-slate-800">{item.text}</p>
                          <p className="text-sm text-slate-500">{item.stat}</p>
                        </div>
                      </motion.div>
                    );
                  })}
                </div>

              </div>
            </div>
          </div>
        </section>

        {/* ===== BENEFITS  ===== */}
        <AnimatedSection className="py-20 bg-white" id="benefits">
          <div className="max-w-5xl mx-auto px-4 sm:px-4 lg:px-6">
            <div className="text-center mb-12 animate-text">
              <h2 className="text-xl sm:text-2xl  md:text-3xl lg:text-4xl font-bold  font-Inter opacity-1 bg-gradient-to-r from-gray-900 via-blue-800 to-fuchsia-800 bg-clip-text text-transparent">
                Why teams pick Roboman
              </h2>
              <p className="mt-3 text-slate-600">
                Outreach that looks handcrafted delivered at scale.
              </p>
            </div>

            <div className="grid  grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 z-0">


              {benefits.items.map((b, index) => {
                const Icon = b.icon;
                const images = [
                  "photo-1460925895917-afdab827c52f",
                  "photo-1551288049-bebda4e38f71",
                  "photo-1512758017271-d7b84c2113f1",
                  "photo-1552664730-d307ca884978",
                  "photo-1553877522-43269d4ea984",
                  "photo-1557804506-669a67965ba0",
                ];

                return (
                  <div
                    key={b.id}
                    className=" group relative overflow-hidden rounded-xl h-[280px]  sm:h-[320px]  md:h-[360px] lg:h-[380px] xl:h-[420px] transition-transform duration-500 hover:scale-[1.03]"
                  >
                    <img
                      src={`https://images.unsplash.com/${images[index]}?w=600&h=800&fit=crop`}
                      alt={b.title}
                      className="absolute inset-0 w-full h-full object-cover scale-110 sm:scale-100 sm:group-hover:scale-125 transition-transform duration-700 will-change-transform"
                    />

                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-transparent group-hover:from-indigo-900/90 group-hover:via-violet-900/70 transition-colors duration-500" />
                    <div className="relative z-10 h-full p-8 flex flex-col justify-end">

                      <div className="inline-flex h-12 w-12 sm:h-14 sm:w-14 rounded-2xl bg-white/10 backdrop-blur-sm text-white items-center justify-center mb-3 sm:mb-4 group-hover:bg-white/20 transition">
                        <Icon className="h-6 w-6 sm:h-7 sm:w-7" />
                      </div>

                      <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white">
                        {b.title}
                      </h3>

                      <p className=" mt-2 sm:mt-3 text-sm sm:text-base  text-slate-200 leading-relaxed">
                        {b.text}
                      </p>
                    </div>

                    <div className="absolute top-4 right-4 opacity-0
                            group-hover:opacity-100 transition-opacity">
                      <div className="h-10 w-10 rounded-full bg-white/20
                              backdrop-blur-sm flex items-center justify-center">
                        <svg
                          className="h-5 w-5 text-white"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                      </div>
                    </div>

                  </div>
                );
              })}
            </div>
          </div>
        </AnimatedSection>

        {/* ===== FEATURES  ===== */}

        <section className="relative min-h-[100svh] px-4 py-12 sm:py-16 lg:py-20 xl:py-24 bg-gradient-to-r from-slate-50 via-slate-100 to-slate-100 text-gray-900 overflow-hidden" id="features">


          <motion.div
            className="absolute top-10 left-1/2 -translate-x-1/2 w-52 h-52 sm:w-64 sm:h-64 lg:w-72 lg:h-72 bg-blue-400/20 rounded-full blur-3xl"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.3, 0.5, 0.3],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              ease: "easeInOut"
            }} />

          <motion.div
            className="absolute bottom-10 right-1/2 translate-x-1/2 w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 bg-purple-400/20 rounded-full blur-3xl"
            animate={{
              scale: [1.2, 1, 1.2],
              opacity: [0.3, 0.5, 0.3],
            }}
            transition={{
              duration: 10,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 1
            }}
          />

          <div className="max-w-4xl mx-auto relative z-10">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-8 space-y-2">

              <div className='flex flex-col sm:flex-row sm:justify-between gap-4 items-center'>
                <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.2, duration: 0.5 }}
                  className="inline-flex items-center gap-2 px-3 py-1.5 bg-violet-60 text-violet-600 rounded-full mb-2 shadow-blue-200"
                >
                  <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
                  >
                    <Sparkles className="w-4 h-4" />
                  </motion.div>
                  <span className="text-sm font-medium">AI-Powered Features</span>
                </motion.div>
                <div className="md:flex gap-2 text-xs text-slate-500 text-center flex items-center justify-center">
                  {['Email', 'LinkedIn', 'Voice', 'Proposals'].map((item, i) => (
                    <motion.span
                      key={item}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.3 + i * 0.1 }}
                      className="px-2 py-1 rounded-full bg-slate-100 animate-pulse"
                    >
                      {item}
                    </motion.span>
                  ))}
                </div>
              </div>

              <motion.h2
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                className="text-xl sm:text-2xl  md:text-3xl lg:text-4xl  leading-tight font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-fuchsia-800 bg-clip-text text-transparent"
              >
                Ship Results, Not Tasks
              </motion.h2>

              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.6 }}
                className="text-sm sm:text-base text-gray-600 max-w-xl mx-auto"
              >
                Everything you need to run successful outreach campaigns and close more deals.
              </motion.p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
              className="flex justify-center flex-wrap gap-2 mb-8"
            >
              {featuresContent.map((_, idx) => (
                <motion.button
                  key={idx}
                  onClick={() => setActiveFeature(idx)}
                  className={`transition-all duration-300 rounded-full ${activeFeature === idx
                    ? 'w-8 h-2 bg-violet-600 shadow-lg'
                    : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'
                    }`}
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                />
              ))}
            </motion.div>

            {/* Feature Cards */}
            <div className="space-y-6">
              <AnimatePresence mode="wait">
                {featuresContent.map((feature, idx) => (
                  <motion.div
                    key={idx}
                    initial={{ opacity: 0, y: 100 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 * idx, duration: 0.5 }}
                    onMouseEnter={() => setHoveredIndex(idx)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    onClick={() => setActiveFeature(idx)}
                    className={`relative group  cursor-pointer transition-all duration-500 ${activeFeature === idx ? 'scale-[1.02]' : 'scale-100 opacity-90 hover:opacity-100'
                      }`}
                  >
                    <motion.div
                      animate={activeFeature === idx ? { scale: 1.02 } : { scale: 1 }}
                      className={`relative bg-white backdrop-blur-xl rounded-2xl border transition-all duration-500 overflow-hidden shadow-md ${activeFeature === idx
                        ? 'border-violet-400 shadow-lg shadow-blue-200/30'
                        : 'border-gray-200 hover:border-gray-300'
                        }`}
                    >
                      {activeFeature === idx && (
                        <motion.div
                          className="absolute inset-0 rounded-2xl"
                          style={{
                            background: 'linear-gradient(90deg, transparent,    rgba(217, 70, 239, 0.3)    , transparent)',
                          }}
                          animate={{
                            x: ['-100%', '100%'],
                          }}
                          transition={{
                            duration: 2,
                            repeat: Infinity,
                            ease: "linear"
                          }}
                        />
                      )}

                      <div className="relative grid grid-cols-1 md:grid-cols-2 gap-6 p-4 sm:p-5 md:p-6">
                        <div className="flex flex-col justify-center space-y-3">
                          <motion.h4
                            initial={{ opacity: 0, x: -100 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8, ease: "easeOut" }}
                            viewport={{ once: true }}
                            className="text-lg sm:text-xl  md:text-2xl lg:text-3xl font-bold text-gray-800 leading-snug">
                            {feature.title}
                          </motion.h4>

                          <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.3 + idx * 0.1 }}
                            className="text-sm text-gray-600 leading-relaxed">
                            {feature.description}
                          </motion.p>

                          <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.4 + idx * 0.1 }}
                            className="flex flex-wrap gap-2 py-2" >

                            <motion.div
                              whileHover={{ scale: 1.05 }}
                              className="px-3 py-1.5 bg-emerald-50 border border-emerald-200 rounded-full text-xs text-emerald-700"
                            >
                              {feature.outcome}
                            </motion.div>
                            <motion.div
                              whileHover={{ scale: 1.05 }}
                              className="px-3 py-1.5 bg-purple-50 border border-purple-200 rounded-full text-xs text-purple-700"
                            >
                              {feature.automationLevel}
                            </motion.div>
                          </motion.div>

                          <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.5 + idx * 0.1 }}
                            className="flex items-center gap-2 mt-2 flex-wrap"
                          >
                            {feature.channels.map((channel, i) => {
                              const Icon = channelIcons[channel] || MessageSquare;
                              return (
                                <motion.div

                                  key={i}
                                  whileHover={{ scale: 1.1, y: -2 }}
                                  className="flex items-center gap-1 px-2 py-1 bg-gray-50 rounded-lg border border-gray-200 hover:border-blue-300 transition-colors text-xs"
                                >
                                  <Icon className="w-3 h-3 text-violet-600" />
                                  <span>{channel}</span>
                                </motion.div>
                              );
                            })}
                          </motion.div>

                          {/* CTA Button */}
                          <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className={`group/btn flex items-center gap-2 px-4 py-2 bg-gradient-to-r  text-violet-600 rounded-lg font-semibold transition-all duration-300 hover:shadow-md hover:shadow-blue-200 w-fit mt-2 ${activeFeature === idx ? 'ring-2 ring-blue-300' : ''
                              }`}
                          >
                            {feature.cta.label}
                            <motion.div
                              animate={{ x: [0, 4, 0] }}
                              transition={{ duration: 1.5, repeat: Infinity }}
                            >
                              <ChevronRight className="w-4 h-4" />
                            </motion.div>
                          </motion.button>
                        </div>

                        {/* IMAGE SIDE */}
                        <motion.div
                          className="flex items-center justify-center"
                          initial={{ opacity: 0, y: 100 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.8, ease: "easeOut" }}
                          viewport={{ once: true }}
                        >
                          <div className="relative">
                            <motion.div
                              animate={
                                activeFeature === idx
                                  ? { scale: 1.05, rotate: [0, 2, 0, -2, 0] }
                                  : { scale: 1, rotate: 0 }
                              }
                              transition={{
                                scale: { duration: 0.3 },
                                rotate: { duration: 2, repeat: Infinity }
                              }}
                              className={`relative w-[280px] h-[220px] rounded-xl overflow-hidden blur-sm transition-all duration-500 ${activeFeature === idx ? 'border-blue-200' : 'border-gray-300'} bg-cover bg-center bg-no-repeat`}
                              style={{
                                backgroundImage: feature.image
                                  ? `url(${feature.image})`
                                  : 'linear-gradient(135deg, #e5e7eb, #f3f4f6)',
                              }}>

                              <motion.div
                                className="absolute inset-0 bg-gradient-to-t from-blue-400/30 to-transparent"
                                animate={{ opacity: [0.2, 0.4, 0.2] }}
                                transition={{ duration: 3, repeat: Infinity }}
                              />
                            </motion.div>

                            <motion.div
                              animate={
                                activeFeature === idx
                                  ? { scale: 1.05, y: [0, -5, 0] }
                                  : { scale: 1, y: 0 }
                              }
                              transition={{
                                scale: { duration: 0.3 },
                                y: { duration: 2, repeat: Infinity }
                              }}
                              className={`absolute -bottom-3 left-1/2 -translate-x-1/2 px-4 py-2 bg-white border rounded-xl shadow-md text-xs transition-all duration-500 ${activeFeature === idx ? 'border-blue-400' : 'border-gray-300'}`}>
                              <div className="text-gray-500 mb-0.5">Auto Trigger</div>
                              <div className="font-semibold text-gray-900 flex items-center gap-1">
                                <Zap className="w-3 h-3 text-blue-600" />
                                {feature.trigger}
                              </div>
                            </motion.div>
                          </div>
                        </motion.div>

                      </div>
                    </motion.div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>

            {/* Footer CTA */}
            {/* <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1, duration: 0.6 }}
              className="mt-12 text-center"
            >
              <div className="inline-flex flex-col items-center gap-3 px-6 py-4 bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-xl shadow-md">
                <p className="text-gray-700 font-medium text-sm">Ready to transform your outreach?</p>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-bold hover:shadow-md hover:shadow-blue-200 transition-all text-sm"
                >
                  Start Free Trial
                </motion.button>
              </div>
            </motion.div> */}
          </div>
        </section>

        {/* ===== Anna ===== */}
        <section className="py-28 bg-gradient-to-b from-slate-50 to-fuchsia-50">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-xl sm:text-2xl  md:text-3xl lg:text-4xl text-center mb-16 font-bold  font-Inter opacity-1 bg-gradient-to-r from-gray-900 via-blue-800 to-fuchsia-800 bg-clip-text text-transparent ">
              How do you want to create your campaign?
            </h2>

            <div className="flex flex-col md:flex-row items-center justify-center gap-12">

              <div
                className={`relative flex flex-col items-center text-center bg-white p-8 rounded-3xl transition-all duration-500
                ${pointingTo === 'left'
                    ? 'scale-105 ring-1 ring-indigo-400 shadow-2xl'
                    : 'opacity-70 hover:opacity-100 hover:shadow-xl'
                  }`}
              >
                <img src={HomeManuallFill} className="w-28 h-28 mb-4 object-contain rounded-xl drop-shadow-md transition-transform duration-300 hover:scale-105" />
                <h3 className="text-xl font-semibold">Manual Campaign</h3>
                <p className="text-slate-600 mt-2">
                  Full control, step-by-step setup.
                </p>
              </div>

              <div className="relative flex flex-col items-center">
                <img
                  src={AnnaImage}
                  className="w-44 h-44 md:w-56 md:h-56 rounded-full"
                />

                <div className="mt-4 bg-indigo-600 text-white px-4 py-1.5 rounded-full text-sm shadow-md">
                  I’ll guide you through it
                </div>
              </div>

              <div
                className={`relative flex flex-col items-center text-center bg-white p-8 rounded-3xl transition-all duration-500
                ${pointingTo === 'right'
                    ? 'scale-105 ring-1 ring-indigo-400 shadow-2xl'
                    : 'opacity-70 hover:opacity-100 hover:shadow-xl'
                  }`}
              >
                <img src={HomecampaignAssistent} className="w-28 h-28 mb-4 object-contain rounded-xl drop-shadow-md transition-transform duration-300 hover:scale-105" />
                <h3 className="text-xl font-semibold">Create with Anna (AI)</h3>
                <p className="text-slate-600 mt-2">
                  Answer a few questions. Anna handles the rest.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/*=== Autopiolet Sequence ==== */}
        <section className="py-14 bg-white">
          <div className="max-w-5xl mx-auto px-4 space-y-12">

            <div className="text-center space-y-2">
              <h2 className="text-xl sm:text-2xl  md:text-3xl lg:text-4xl font-bold  font-Inter opacity-1 bg-gradient-to-r from-gray-900 via-blue-800 to-fuchsia-800 bg-clip-text text-transparent">
                Autopilot Sequences
              </h2>
              <p className="text-sm text-gray-500">
                Choose the outreach intensity that fits your campaign
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

              <div className="rounded-xl border border-gray-200 p-5">
                <h3 className="font-medium text-emerald-600">Conservative</h3>
                <p className="text-xs text-gray-500 mt-1">
                  Safer delivery with simple outreach
                </p>

                <ul className="mt-4 space-y-2 text-sm text-gray-700">
                  <li className="flex gap-2">  Simple text follow-up</li>
                  <li className="flex gap-2">4 Emails</li>
                  <li className="flex gap-2"> 4 LinkedIn messages</li>
                </ul>
              </div>

              <div className="rounded-xl border border-violet-300 bg-violet-50/40 p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-medium text-violet-600">Balanced</h3>
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-violet-600 text-white">
                    Recommended
                  </span>
                </div>

                <p className="text-xs text-gray-500 mt-1">
                  Best mix of volume & personalization
                </p>

                <ul className="mt-4 space-y-2 text-sm text-gray-700">
                  <li className="flex gap-2"> Proposal mide sequence and one voice note</li>
                  <li className="flex gap-2"> 4 Emails (includes proposal)</li>
                  <li className="flex gap-2"> 4 LinkedIn (includes proposal + voice note)</li>
                </ul>
              </div>

              <div className="rounded-xl border border-gray-200 p-5">
                <h3 className="font-medium text-rose-600">Aggressive</h3>
                <p className="text-xs text-gray-500 mt-1">
                  Maximum impact in short sprints
                </p>

                <ul className="mt-4 space-y-2 text-sm text-gray-700 ">
                  <li className="flex gap-2"> Front-loaded proposal</li>
                  <li className="flex gap-2"> 4 fast-paced emails(proposal)</li>
                  <li className="flex gap-2"> LinkedIn voice follow-ups(proposal+ voice note)</li>
                </ul>
              </div>

            </div>

            {/* Hint */}
            <p className="text-center text-xs text-gray-400">
              You can adjust your outreach strategy anytime.
            </p>

            {/* Sequence Preview Image */}
            <div className="flex justify-center pt-6">
              <img
                src={HomeSequence}
                alt="Sequence preview"
                className="w-[70%] cover"
              />
            </div>

          </div>
        </section>


        {/* ===== TESTIMONIALS ===== */}
        <AnimatedSection className="py-28 relative overflow-hidden bg-gradient-to-r from-slate-50 via-slate-100 to-slate-100" id="testimonials">
          {/* Background blobs */}
          <div className="absolute -top-32 -left-32 w-96 h-96 bg-violet-200/40 rounded-full blur-3xl" />
          <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-blue-200/40 rounded-full blur-3xl" />

          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Header */}
            <div className="text-center max-w-3xl mx-auto">
              <h2 className="text-xl sm:text-2xl  md:text-3xl lg:text-4xl font-bold font-Inter opacity-1 bg-gradient-to-r from-gray-900 via-blue-800 to-fuchsia-800 bg-clip-text text-transparent">
                Loved by teams worldwide
              </h2>
              <p className="mt-3 text-slate-500 text-sm">
                Real outcomes from real revenue teams.
              </p>
            </div>

            {/* Cards */}
            <div className="mt-16 grid gap-8 lg:grid-cols-3 ">
              {testimonials.items.map((t, index) => (
                <div
                  key={t.id}
                  className="group relative rounded-3xl bg-gradient-to-bl from-indigo-100 via-violet-100 to-fuchsia-100 backdrop-blur
                     p-8 ring-1 ring-slate-200 shadow-lg
                     transition-all duration-300
                     hover:-translate-y-2 hover:shadow-2xl"
                >
                  {/* Quote Icon */}
                  <span className="absolute -top-4 right-6 text-6xl text-violet-100 group-hover:text-violet-200 transition">
                    “
                  </span>

                  {/* Rating */}
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <Star key={i} className="h-4 w-4 text-yellow-400" />
                    ))}
                  </div>

                  {/* Feedback */}
                  <p className="text-slate-700 text-md leading-relaxed">
                    {t.feedback}
                  </p>

                  {/* User */}
                  <div className="mt-8 flex items-center gap-4">
                    <div className="relative">
                      <img
                        src={t.avatarUrl}
                        alt={t.name}
                        className="w-14 h-14 rounded-full ring-2 ring-slate-200"
                      />
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">{t.name}</p>
                      <p className="text-sm text-slate-500">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </AnimatedSection>





        {/* ===== INTEGRATIONS (horizontal rail) ===== */}
        {/* <AnimatedSection className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-semibold text-slate-900">Works with your stack</h3>
              <p className="text-sm text-slate-400">Connect Roboman in seconds</p>
            </div>
            <div className="mt-6 flex gap-3 overflow-x-auto no-scrollbar">
              {['Gmail', 'Outlook', 'Salesforce', 'HubSpot', 'Zapier'].map((n, i) => (
                <div key={i} className="flex-shrink-0 rounded-2xl bg-slate-50 ring-1 ring-slate-200 px-5 py-3 text-slate-700 font-semibold">{n}</div>
              ))}
            </div>
          </div>
        </AnimatedSection> */}







        {/* ===== PRICING (ticket cards) =====
        <AnimatedSection className="py-24 bg-slate-50" id="pricing">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h2 className="text-3xl font-extrabold tracking-tight text-slate-900">Flexible credit packages</h2>
              <p className="mt-3 text-slate-600">One-time purchase, no subscriptions.</p>
              <div className="mt-6 inline-flex flex-wrap gap-2 p-1 bg-slate-200 rounded-full">
                {pricingData.currencies.map((c) => (
                  <button key={c.id} onClick={() => setSelectedCurrency(c.id)} className={`min-w-[9rem] text-sm font-semibold py-2 px-4 rounded-full transition ${selectedCurrency===c.id ? 'bg-white text-slate-900 shadow ring-1 ring-slate-200' : 'text-slate-600 hover:text-slate-900'}`}>{c.name}</button>
                ))}
              </div>
            </div>

            <div className="mt-12 grid lg:grid-cols-4 gap-6 items-stretch">
              {pricingData.plans.map((p)=> (
                <div key={p.id} className={`relative rounded-2xl bg-white ring-1 p-6 flex flex-col ${p.recommended? 'ring-indigo-500 shadow-2xl scale-[1.02]' : 'ring-slate-200 shadow-lg'}`}>
                  {p.recommended && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-indigo-600 text-white text-[10px] font-semibold px-3 py-1 rounded-full uppercase tracking-wider">Most Popular</span>}
                  <div className="text-center">
                    <h3 className="text-xl font-bold text-slate-900">{p.title}</h3>
                    <p className="mt-3 text-4xl font-extrabold text-slate-900">
                      {p.prices[selectedCurrency] !== 'Custom' && pricingData.currencies.find(c => c.id === selectedCurrency).symbol}
                      {p.prices[selectedCurrency]}
                      {p.vat && p.vat[selectedCurrency] && <span className="text-sm font-medium text-slate-400">+VAT</span>}
                    </p>
                    <p className="text-sm font-semibold text-indigo-600">{p.credits} Credits</p>
                  </div>

                  {p.features && (
                    <div className="mt-6 border-t pt-6 space-y-2">
                      {p.features.map((f,i)=> (
                        <p key={i} className="text-slate-600 text-sm flex items-start justify-center"><span className="mr-2 mt-0.5"><CheckCircle className="h-4 w-4 text-emerald-500"/></span>{f}</p>
                      ))}
                    </div>
                  )}
                  {p.mixExample && (
                    <div className="mt-6 border-t pt-6 text-center">
                      <p className="text-xs font-bold text-slate-700">{p.mixExample.title}</p>
                      {p.mixExample.items.map((it, i)=> (<p key={i} className="text-[12px] text-slate-500">{it}</p>))}
                    </div>
                  )}
                  {p.priceInfo && <p className="text-center text-sm text-slate-500 mt-4">{p.priceInfo}</p>}

                  <div className="mt-auto pt-6">
                    <button onClick={() => navigate('/signup')} className={`w-full py-3 px-6 rounded-lg font-semibold transition-colors ${p.recommended ? 'bg-indigo-600 text-white hover:bg-indigo-700' : 'bg-indigo-50 text-indigo-700 hover:bg-indigo-100'}`}>
                      {p.title === 'Enterprise' ? 'Contact Sales' : 'Buy Credits'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </AnimatedSection> */}

        <HomepagePricingSection />

        {/* ===== FINAL CTA ===== */}
        <AnimatedSection className="py-24">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="relative overflow-hidden rounded-3xl">
              <div className="absolute inset-0  bg-gradient-to-r from-indigo-600 via-violet-700 to-fuchsia-700 " />
              <div className="absolute inset-0 opacity-25 grid-bg" />
              <div className="relative text-center p-12">
                <h2 className="text-4xl font-extrabold  font-Inter opacity-1 bg-gradient-to-r from-white via-blue-100 to-slate-200  bg-clip-text text-transparent tracking-tight">{finalCta.prompt}</h2>
                <button onClick={() => navigate('/signup')} className="mt-8 inline-flex items-center gap-2 group px-8 py-4 bg-white text-slate-900 font-bold rounded-full shadow-2xl ring-1 ring-slate-200 transition-transform duration-300 hover:scale-[1.03]">
                  {finalCta.buttonText}
                  <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
                </button>
                <p className="mt-4 text-sm text-indigo-50">{finalCta.note}</p>
              </div>
            </div>
          </div>
        </AnimatedSection>
      </main>

      <Footer />

    </div>
  );
};

export default HomeNew;
